import { useState } from "react";
import { useDispatch } from "react-redux";
import { Box, TextField } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import { requestResetPassword } from "../store/slices/userSlice";
import { forgotPasswordSteps, loginMessages } from "../constants";
import AuthCard from "../components/Auth/AuthCard";
import {
  BackToLoginLink,
  StepHeader,
  StepMessage,
  submitButtonSx,
} from "../components/Auth/common";

export default function ForgotPassword() {
  const dispatch = useDispatch();
  const [email, setEmail] = useState("");
  const [step, setStep] = useState(forgotPasswordSteps.REQUEST);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState("");

  const trimmedEmail = email.trim();

  async function handleSubmit(event) {
    event.preventDefault();
    if (!trimmedEmail) return;

    setIsSubmitting(true);
    setError("");
    const result = await dispatch(requestResetPassword(trimmedEmail));
    setIsSubmitting(false);

    if (requestResetPassword.fulfilled.match(result)) return setStep(forgotPasswordSteps.SENT);

    const message = result.payload?.message;
    setError(typeof message === "string" ? message : loginMessages.GENERIC_ERROR);
  }

  return (
    <AuthCard step={step}>
      {step === forgotPasswordSteps.SENT ? (
        <>
          <StepHeader title="Reset password link has been sent to your email">
            You should receive an email shortly to create a new one.
          </StepHeader>

          <BackToLoginLink />
        </>
      ) : (
        <Box component="form" noValidate onSubmit={handleSubmit}>
          <StepHeader title="Forgot password">
            What is the email address for your account?
          </StepHeader>

          <TextField
            fullWidth
            autoFocus
            type="email"
            name="email"
            label="Email"
            autoComplete="email"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            margin="dense"
          />

          <StepMessage error={error} />

          <LoadingButton
            fullWidth
            type="submit"
            variant="contained"
            loading={isSubmitting}
            disabled={!trimmedEmail}
            sx={{ ...submitButtonSx, mb: 3 }}
          >
            Request reset password
          </LoadingButton>

          <BackToLoginLink />
        </Box>
      )}
    </AuthCard>
  );
}
